import React, { useState } from 'react';
import { Save, X } from 'lucide-react';

import { useToast } from './toastContext';

const NodeFormModal = ({ mode, node, onClose, onSave }) => {
    const toast = useToast();

    const [name, setName] = useState(node?.name || '');
    const [description, setDescription] = useState(node?.description || '');
    const [responsibleOrg, setResponsibleOrg] = useState(node?.responsibleOrg || '');
    const [responsibleName, setResponsibleName] = useState(node?.responsibleName || '');
    const [managementOrg, setManagementOrg] = useState(node?.managementOrg || '');
    const [managementName, setManagementName] = useState(node?.managementName || '');

    const handleSave = () => {
        if (!name.trim()) {
            toast.warning('Введите наименование узла');
            return;
        }

        onSave({
            name: name.trim(),
            description: description.trim() || null,
            responsibleOrg: responsibleOrg.trim() || null,
            responsibleName: responsibleName.trim() || null,
            managementOrg: managementOrg.trim() || null,
            managementName: managementName.trim() || null
        });
    };

    return (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50 p-4">
            <div className="bg-slate-800 rounded-xl border border-slate-700 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
                <div className="px-4 py-3 border-b border-slate-700 flex items-center justify-between sticky top-0 bg-slate-800 z-10">
                    <h3 className="text-white font-semibold">
                        {mode === 'create' ? 'Создать узел учёта' : 'Редактировать узел'}
                    </h3>

                    <button
                        onClick={onClose}
                        className="text-slate-400 hover:text-white"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>

                <div className="p-4 space-y-4">
                    <div className="bg-slate-900/50 rounded-lg p-3 border border-slate-700">
                        <h4 className="text-white font-medium text-sm mb-3">
                            Основная информация
                        </h4>

                        <div className="space-y-3">
                            <div>
                                <label className="block text-slate-400 text-xs mb-1">
                                    Наименование узла <span className="text-red-400">*</span>
                                </label>

                                <input
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    className="w-full px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm"
                                    placeholder="Узел учёта №1 (подвал)"
                                    autoFocus
                                />
                            </div>

                            <div>
                                <label className="block text-slate-400 text-xs mb-1">
                                    Описание
                                </label>

                                <textarea
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    className="w-full px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm min-h-[60px] resize-y"
                                    placeholder="Центральный тепловой пункт"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="bg-slate-900/50 rounded-lg p-3 border border-slate-700">
                        <h4 className="text-white font-medium text-sm mb-3">
                            Ответственные
                        </h4>

                        <div className="grid grid-cols-2 gap-3">
                            <div>
                                <label className="block text-slate-400 text-xs mb-1">
                                    Организация (ответственный)
                                </label>

                                <input
                                    type="text"
                                    value={responsibleOrg}
                                    onChange={(e) => setResponsibleOrg(e.target.value)}
                                    placeholder='ООО "НПО Автоматика-Сервис"'
                                    className="w-full px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm"
                                />
                            </div>

                            <div>
                                <label className="block text-slate-400 text-xs mb-1">
                                    ФИО ответственного
                                </label>

                                <input
                                    type="text"
                                    value={responsibleName}
                                    onChange={(e) => setResponsibleName(e.target.value)}
                                    placeholder="Т. В. Кайсарова"
                                    className="w-full px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm"
                                />
                            </div>

                            <div>
                                <label className="block text-slate-400 text-xs mb-1">
                                    Управляющая организация (владелец)
                                </label>

                                <input
                                    type="text"
                                    value={managementOrg}
                                    onChange={(e) => setManagementOrg(e.target.value)}
                                    placeholder='ООО "УК Златоград"'
                                    className="w-full px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm"
                                />
                            </div>

                            <div>
                                <label className="block text-slate-400 text-xs mb-1">
                                    ФИО директора
                                </label>

                                <input
                                    type="text"
                                    value={managementName}
                                    onChange={(e) => setManagementName(e.target.value)}
                                    placeholder="В. Ю. Сергеев"
                                    className="w-full px-3 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white text-sm"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="px-4 py-3 border-t border-slate-700 flex justify-end gap-2 sticky bottom-0 bg-slate-800">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg text-sm"
                    >
                        Отмена
                    </button>

                    <button
                        onClick={handleSave}
                        className="px-4 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded-lg text-sm flex items-center gap-2"
                    >
                        <Save className="w-4 h-4" />
                        {mode === 'create' ? 'Создать' : 'Сохранить'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NodeFormModal;